import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { BUDGET } from "./apiRoutes";

interface UseGetCommentsByBudgetIdProps {
  communityId: string;
  budgetId: string;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getCommentsByBudgetId = async (
  communityId: string,
  budgetId: string
) =>
  await axiosAuth.get(
    `${BUDGET(communityId)}/${budgetId}/comments`
  );

const useGetCommentsByBudgetId = ({
  queryParams,
  communityId,
  budgetId,
}: UseGetCommentsByBudgetIdProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["budget-comments", communityId, budgetId],

    queryFn: () => getCommentsByBudgetId(communityId, budgetId),

    select: (data: any) => data.data,

    refetchOnWindowFocus: false,

    ...queryParams,

    enabled: !!communityId && !!budgetId && (queryParams?.enabled ?? true),
  });
};

export default useGetCommentsByBudgetId;
